import { useTranslation } from "react-i18next";
import { useAuth } from "./AuthContext.js";
import "./UserMenu.css";

export function UserMenu(): JSX.Element | null {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  if (!user) return null;
  const initials = user.displayName
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return (
    <div className="user-menu">
      <span className="user-avatar" aria-hidden="true">
        {initials}
      </span>
      <span className="user-name">{user.displayName}</span>
      <button type="button" className="user-logout" onClick={logout}>
        {t("auth.logout")}
      </button>
    </div>
  );
}
